import { render, staticRenderFns } from "./expo-employee-form.vue?vue&type=template&id=547b0e6a"
import script from "./expo-employee-form.vue?vue&type=script&lang=js"
export * from "./expo-employee-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports